import SafeOtpApi from './SafeOtpApi'

export default {
  /** for test */
  async apply (params) {
    return this.callApi('/localdomain/apply', params);
  },
  async register (params) {
    return this.callApi('/localdomain/register', params)
  },
  async check (params) {
    return this.callApi('/localdomain/check', params)
  },
  async request (params) {
    return this.callApi('/localdomain/request', params)
  },
  async verify (params) {
    return this.callApi('/localdomain/verify', params)
  },
  callApi (path, params) {
    // console.log('start api path = ', path)
    // console.log('start api params = ', params)
    
    return new Promise((resolve, reject) => {
      SafeOtpApi().post(path, params)
      .then((response) => {
        // console.log('sevice success = ', response)
        resolve(response.data)
      })
      .catch((error) => {
        // console.log('service err ', error)
        // console.log('service err ', error.response)
        // console.log('service err ', error.status)
        if (error.response.status === 400 && error.response.data.status == 902) {
          alert(error.response.data.message)
          return
        }        
        // if(error.response.status === 500) {}
        reject(error)
      })
    })
  }
}